<template>

  <div class="accordion-wrapper">

    <template v-for="(accordion, index) in accordionParsed">

      <div :class="[{open: accordion.active}, 'accordion']" :id="accordion.anchor!==''?accordion.anchor:accordion.outer.toLowerCase().replace(' ', '-')" :key="index">
        
      <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">  
        <div class="outer">
          <div class="plus" @click="open(accordion)">
            <div class="plus-inner">
              <div class="horizontal"></div>
              <div class="vertical"></div>
            </div>
          </div>
          <div itemprop="name">
          <a v-html="accordion.outer" @click="open(accordion)"></a>
        </div>
        </div>

      <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
        <div class="inner" v-html="accordion.inner" itemprop="text"></div>
        </div>
      </div>
      </div>

    </template>

  </div>

</template>

<style scoped>
  .accordion .outer {
    cursor: pointer;
  }
</style>

<script>
  export default {
    name: 'Accordion',
    props: ['accordion-json'],
    data () {
      return {
        accordionParsed : JSON.parse(this.accordionJson),
      }
    },
    mounted() {

    },
    methods: {
      open: function(accordion) {
        accordion.active = !accordion.active;
      }
    }
  }
</script>
